package com.milta.core.localization

/**
 * Strings specific to the Excel/CSV spreadsheet import flow (contrat validé MIL-27,
 * `SpreadsheetImportScreen` / `SpreadsheetValidationScreen`). Deliberately separate from
 * [ImportsStrings] (MIL-29 Photo/PDF/Excel import, superseded contract) — different backend
 * endpoint, different response shape. Wherever the wording is identical to the OCR paper-list
 * flow (MIL-24/DOM-02), members of [OcrScanStrings] are reused directly instead of being
 * duplicated here — see the mockup's own "Mapping composants réels" notes for which ones
 * (missing-field labels/warnings, correction field labels, "Ajouter à la tournée" prefix,
 * "Vérifier les données" title).
 */
data class SpreadsheetImportStrings(
    // ── Écrans B/F/G/H — navbar ──
    val importFileTitle: String,
    // ── Écran B — analyse du fichier ──
    val analysingTitle: String,
    val analysingSubtitle: String,
    val fileSentSuffix: String,
    // ── Écrans C/D — bandeau selon IsStructuredFormat ──
    val structuredFormatBannerTitle: String,
    val structuredFormatBannerMessage: String,
    val columnsInterpretedBannerTitle: String,
    val columnsInterpretedBannerMessage: String,
    val completePillLabel: String,
    // ── Écran F — 400 fichier invalide ou format non supporté ──
    val invalidFileTitle: String,
    val invalidFileMessage: String,
    val chooseAnotherFileButton: String,
    // ── Écran G — 422 extraction échouée ──
    val extractionFailedTitle: String,
    val extractionFailedMessage: String,
    val retryWithNewFileButton: String,
    // ── Écran H — 503 service d'analyse indisponible ──
    val serviceUnavailableTitle: String,
    val serviceUnavailableMessage: String,
)
